import { QueryClient } from '@tanstack/react-query'

const getErrorStatus = (error: unknown): number | undefined => {
    if (error && typeof error === 'object' && 'response' in error) {
        const res = (error as { response?: { status?: number } }).response
        return res?.status
    }
    return undefined
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error: unknown) => {
                const status = getErrorStatus(error)
                // Try not to repeat on 401/403; otherwise up to 3 attempts
                if (status === 403 || status === 401) {
                    return false
                }
                return failureCount < 3
            },
            retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
            staleTime: 1000 * 60 * 5,
            gcTime: 1000 * 60 * 30,
        },
        mutations: {
            retry: (_failureCount, error: unknown) => {
                const status = getErrorStatus(error)
                // Mutations are not retried (including on 401/403)
                if (status === 403 || status === 401) {
                    return false
                }
                return false
            },
        },
    },
})
